import React from 'react';
import { TypedName } from './components/TypedName';
import { EsignDate } from './components/EsignDate';
import { Title } from './components/Title';

export const SigningInformation: React.FC = () => {
    return (
        <>
            <h3 style={{ marginTop: 30 }}>Finalize Information</h3>
            <TypedName />
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                <Title />
                <EsignDate />
            </div>
        </>
    );
};
